import config from "@core/config/env";

/**
 * Get the full URL for a file, handling both local and Azure Blob Storage URLs
 * @param {string} filePath - The file path or URL
 * @returns {string} - Full URL to the file
 */
export const getFileUrl = (filePath) => {
  // Return empty string if no path provided
  if (!filePath) {
    return "";
  }

  // If it's already a full URL (Azure Blob Storage or external URL), return as-is
  if (
    filePath.startsWith("http://") ||
    filePath.startsWith("https://") ||
    filePath.startsWith("data:")
  ) {
    return filePath;
  }

  // Otherwise, it's a local path - prepend the fileUrl
  // Remove leading slash if present to avoid double slashes
  const cleanPath = filePath.startsWith("/") ? filePath.slice(1) : filePath;
  return `${config.fileUrl}/${cleanPath}`;
};

/**
 * Check if a file URL is from Azure Blob Storage
 * @param {string} url - The URL to check
 * @returns {boolean} - True if it's an Azure Blob Storage URL
 */
export const isAzureBlobUrl = (url) => {
  if (!url) return false;
  return url.includes(".blob.core.windows.net");
};

/**
 * Check if a file URL is a local file
 * @param {string} url - The URL to check
 * @returns {boolean} - True if it's a local file path
 */
export const isLocalFile = (url) => {
  if (!url) return false;
  return (
    !url.startsWith("http://") &&
    !url.startsWith("https://") &&
    !url.startsWith("data:")
  );
};
